export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5"},{"charset":"utf-8"},{"name":"description","content":"Fysio Hier in Uden helpt je bij het verminderen van pijn en het verbeteren van je bewegelijkheid. Persoonlijke fysiotherapie, zonder wachtlijst, met aandacht voor jouw herstel."},{"property":"og:description","content":"Fysio Hier in Uden helpt je bij het verminderen van pijn en het verbeteren van je bewegelijkheid. Persoonlijke fysiotherapie, zonder wachtlijst, met aandacht voor jouw herstel."},{"property":"og:image","content":"https://fysiohier.com/img/open-graph/fysio-hier-1200x630.png"},{"property":"og:image:width","content":"1200"},{"property":"og:image:height","content":"630"},{"property":"og:image","content":"https://fysiohier.com/img/open-graph/fysio-hier-1200x675.png"},{"property":"og:image:height","content":"675"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/img/favicon/favicon-16x16.png","sizes":"16x16"},{"rel":"icon","type":"image/x-icon","href":"/img/favicon/favicon-32x32.png","sizes":"32x23"},{"rel":"icon","type":"image/x-icon","href":"/img/favicon/favicon-48x48.png","sizes":"48x48"},{"rel":"icon","type":"image/x-icon","href":"/img/favicon/favicon-76x76.png","sizes":"76x76"},{"rel":"icon","type":"image/x-icon","href":"/img/favicon/favicon-96x96.png","sizes":"96x96"},{"rel":"icon","type":"image/x-icon","href":"/img/favicon/favicon-120x120.png","sizes":"120x120"},{"rel":"icon","type":"image/x-icon","href":"/img/favicon/favicon-128x128.png","sizes":"128x128"},{"rel":"icon","type":"image/x-icon","href":"/img/favicon/favicon-144x144.png","sizes":"144x144"},{"rel":"icon","type":"image/x-icon","href":"/img/favicon/favicon-152x152.png","sizes":"152x152"},{"rel":"icon","type":"image/x-icon","href":"/img/favicon/favicon-167x167.png","sizes":"167x167"},{"rel":"icon","type":"apple-touch-icon","href":"/img/favicon/touch-icon-180x180.png","sizes":"180x180"},{"rel":"icon","type":"image/x-icon","href":"/img/favicon/favicon-192x192.png","sizes":"192x192"},{"rel":"icon","type":"image/x-icon","href":"/img/favicon/favicon-196x196.png","sizes":"196x196"},{"rel":"icon","type":"image/x-icon","href":"/img/favicon/favicon-228x228.png","sizes":"228x228"},{"rel":"icon","type":"image/x-icon","href":"/img/favicon/favicon-256x256.png","sizes":"256x256"},{"rel":"icon","type":"image/x-icon","href":"/img/favicon/favicon-300x300.png","sizes":"300x300"},{"rel":"icon","type":"image/x-icon","href":"/img/favicon/favicon-384x384.png","sizes":"384x384"},{"rel":"icon","type":"image/x-icon","href":"/img/favicon/favicon-512x512.png","sizes":"512x512"},{"rel":"manifest","href":"/manifest.webmanifest"}],"style":[],"script":[{"type":"application/ld+json","innerHTML":{"@context":"https://schema.org","@type":"WebSite","name":"Fysio Hier","alternateName":["Fysiotherapie Hier","Fysiopraktijk Hier","Fysio Hier Uden","Fysiotherapie Hier Uden","Fysiopraktijk Hier Uden"],"url":"https://fysiohier.com/","potentialAction":[{"@context":"https://schema.org","@type":"PlanAction","target":"https://fysiohier.com/?d=afspraak-inplannen","name":"Afspraak maken"}]}}],"noscript":[],"viewport":"width=device-width, initial-scale=1, maximum-scale=5","htmlAttrs":{"lang":"nl"},"title":"Fysio Hier | Fysiotherapie Uden"}

export const appPageTransition = false

export const appLayoutTransition = false

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const resetAsyncDataToUndefined = false

export const nuxtDefaultErrorValue = undefined

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false